import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { APPS } from 'src/app/dummy/app';
import { AddFacultyComponent } from './add-faculty/add-faculty.component';
import { tabs } from 'src/app/dummy/tabs';
import { AuthService } from 'src/app/auth/auth.service';
import { LazyData } from 'src/app/stores/administrator/lazyData.store';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-faculty',
  templateUrl: './faculty.component.html',
  styleUrls: ['./faculty.component.scss']
})
export class FacultyComponent implements OnInit {
  tabs = tabs.FACULTY

  constructor(
    private auth: AuthService,
    public store: LazyData,
    public list: List,
    public rotue: ActivatedRoute,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddFacultyComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    this.store.fetchData(this.ds.facultyRef(ref => ref
      .orderBy('page_key')
      .limit(APPS.SIZE)))
    await this.auth.fetchEnvironment()

  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.fetchMore(this.ds.facultyRef(ref => ref
      .orderBy('page_key')
      .startAfter(lastVisible.page_key)
      .limit(APPS.SIZE)))
  }

  // ngOnDestroy() {
  //   this.store.dispost();
  // }
}
